import { render, staticRenderFns } from "./dailyQuestion.vue?vue&type=template&id=83910580&scoped=true"
import script from "./dailyQuestion.vue?vue&type=script&lang=js"
export * from "./dailyQuestion.vue?vue&type=script&lang=js"
import style0 from "./dailyQuestion.vue?vue&type=style&index=0&id=83910580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83910580",
  null
  
)

export default component.exports